import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UISection from 'UIComponents/section/UISection';
import Rating from 'marketplace-ui-reviews/components/Rating';
import { Reportables } from 'marketplace-ui-reviews/constants/ReportReasons';
import { RatingAxes } from 'marketplace-ui-reviews/constants/RatingAxes';
import HelpfulButton from 'marketplace-ui-reviews/components/HelpfulButton';
import ReviewActionsWrapper from 'marketplace-ui-reviews/components/ReviewActionsWrapper';
import ReportButton from 'marketplace-ui-reviews/components/ReportButton';
import ReviewBody from 'marketplace-ui-reviews/components/ReviewBody';
import ReviewerInfo from 'marketplace-ui-reviews/components/ReviewerInfo';
import ReviewReplyThread from 'marketplace-ui-reviews/components/ReviewReplyThread';
import ReportReviewModal from 'marketplace-ui-reviews/components/modals/ReportReviewModal'; // @ts-expect-error untyped dependency

import { makeGetUserMarkedHelpfulSelector } from '../../selectors/reviews';
import { reportReply, reportReview, toggleReviewHelpful // @ts-expect-error untyped dependency
} from '../../actions/ReviewsActions'; // @ts-expect-error untyped dependency

import { getIsCustomer, getUserId } from '../../selectors/auth';
export default function AssetReviewRenderer({
  borderBottom,
  review,
  searchTerm,
  reviewType
}) {
  const dispatch = useDispatch();
  const [reportModalType, setReportModalType] = useState(null);
  const isCustomer = useSelector(getIsCustomer);
  const userId = useSelector(getUserId);
  const ratingValue = review.getIn(['ratings', RatingAxes.OVERALL]);
  const getUserMarkedHelpful = useMemo(makeGetUserMarkedHelpfulSelector, []);
  const userMarkedHelpful = useSelector(state => getUserMarkedHelpful(state, review.get('id')));
  const handleClickHelpful = useCallback(() => {
    dispatch(toggleReviewHelpful(review.get('id'), userId, !userMarkedHelpful));
  }, [dispatch, review, userId, userMarkedHelpful]);
  const renderedReportModal = useMemo(() => {
    const onConfirmAction = (reportReason, comment) => reportModalType === Reportables.REVIEW ? reportReview({
      reviewId: review.get('id'),
      reportReason,
      comment
    }) : reportReply({
      reviewId: review.get('id'),
      replyId: review.getIn(['reply', 'id']),
      reportReason,
      comment
    });

    return /*#__PURE__*/_jsx(ReportReviewModal, {
      review: review,
      onClose: () => {
        setReportModalType(null);
      },
      onConfirm: ({
        reason,
        comment
      }) => {
        dispatch(onConfirmAction(reason, comment));
        setReportModalType(null);
      }
    });
  }, [dispatch, review, reportModalType]);
  const reviewActions = useMemo(() => {
    return /*#__PURE__*/_jsxs(ReviewActionsWrapper, {
      children: [/*#__PURE__*/_jsx(HelpfulButton, {
        className: "m-right-2",
        disabled: !isCustomer,
        helpfulCount: review.getHelpfulCount(),
        onClickHelpful: handleClickHelpful,
        userMarkedHelpful: userMarkedHelpful
      }), /*#__PURE__*/_jsx(ReportButton, {
        className: "m-left-2",
        isCustomer: isCustomer,
        onClick: () => setReportModalType(Reportables.REVIEW)
      })]
    });
  }, [handleClickHelpful, isCustomer, review, userMarkedHelpful]);
  return /*#__PURE__*/_jsxs("div", {
    className: "p-y-8",
    style: {
      width: '100%',
      borderBottom: borderBottom ? `1px solid ${GREAT_WHITE}` : undefined
    },
    children: [/*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(Rating, {
        direction: "column",
        label: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: review.get('createdAt'),
          format: "ll",
          type: "userTz"
        }),
        rating: ratingValue || 0,
        showTextRating: true
      })
    }), /*#__PURE__*/_jsx(ReviewBody, {
      review: review,
      searchTerm: searchTerm,
      reviewType: reviewType
    }), /*#__PURE__*/_jsx(ReviewerInfo, {
      review: review,
      inline: true
    }), reviewActions, /*#__PURE__*/_jsx(ReviewReplyThread, {
      reply: review.get('reply'),
      onReportReplyClick: () => setReportModalType(Reportables.REPLY)
    }), reportModalType && renderedReportModal]
  });
}